import type { ReactNode } from "react";
import { Tooltip } from "@/components/ui/Tooltip";

interface MetricProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  tone?: "default" | "err" | "accent";
  hint?: string;
  children?: ReactNode;
}

export function Metric({ label, value, sub, tone = "default", hint, children }: MetricProps) {
  return (
    <div className="metric" data-tone={tone}>
      <div className="label-row">
        <div className="label">{label}</div>
        {hint && <Tooltip tip={hint} label={label} />}
      </div>
      <div className={["value", tone === "err" && "err"].filter(Boolean).join(" ")}>{value}</div>
      {sub && <div className="sub">{sub}</div>}
      {children}
    </div>
  );
}
